import { Component, OnInit } from '@angular/core';
import { KatalogeService } from '../../services/kataloge.service';
import { Katalog } from '../../shared/model/katalog.model';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { INPUT_LIMITS } from '../../shared/constants/input-limits';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';

@Component({
  selector: 'app-catalogues',
  imports: [
    RouterLink,
    FormsModule,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    TranslatePipe,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
  ],
  templateUrl: './catalogues.component.html',
  styleUrl: './catalogues.component.scss',
  standalone: true,
})
export class CataloguesComponent implements OnInit {
  protected get LIMITS() { return INPUT_LIMITS; }
  kataloge: Katalog[];
  isPopupOpen = false;
  katalogForm = {
    preisgruppe: null as number | null,
    rvseVersion: null as number | null,
    kuerzel: '',
    rollenbezeichnung: '',
  };
  displayedColumns: string[] = [
    'RVSE',
    'PG',
    'shortHandSymbol',
    'role',
    'edit',
  ];

  constructor(private katalogservice: KatalogeService) {}

  ngOnInit() {
    this.subscribeToSaveResponse(this.katalogservice.query());
  }

  openMenu() {
    this.isPopupOpen = true;
  }

  closeMenu() {
    this.isPopupOpen = false;
  }

  addKatalog() {
    const newKatalog = { ...this.katalogForm };

    this.katalogservice
      .create(
        newKatalog.kuerzel,
        newKatalog.rvseVersion,
        newKatalog.preisgruppe,
        newKatalog.rollenbezeichnung,
      )
      .subscribe((res) => {
        this.kataloge.push(res.body);
        this.closeMenu();
      });

    this.katalogForm = {
      preisgruppe: null,
      rvseVersion: null,
      kuerzel: '',
      rollenbezeichnung: '',
    };
    this.closeMenu();
  }

  protected subscribeToSaveResponse(
    result: Observable<HttpResponse<Katalog[]>>,
  ) {
    result.subscribe((res: HttpResponse<Katalog[]>) => {
      this.kataloge = res.body;
    });
  }
}
